export default __webpack_public_path__ + "text-labelsf00b71.png";